import { InboxMessageCriteria } from '@src/main/modules/messages/domain/message/inbox/inbox-message-criteria.interface';
import { InboxMessage } from '@src/main/modules/messages/domain/message/inbox/inbox-message.interface';
import { InboxMessageRepository } from '@src/main/modules/messages/domain/message/inbox/inbox-message.repository';
import { PageResponse } from '@src/main/shared/infrastructure/entity/page.entity';

export const findInboxMessagesByCriteria = async (
  repository: InboxMessageRepository,
  criteria: InboxMessageCriteria,
): Promise<PageResponse<InboxMessage>> => await repository.findByCriteria(criteria);
